import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {ToolbarComponent} from './toolbar/toolbar.component';
import {SplitterComponent} from './splitter/splitter.component';
import {MenuLeftComponent} from './menu-left/menu-left.component';
import {RouterModule} from '@angular/router';
import { HomeModule } from '../home/home.module';
import { CustomCard2Component } from './menu-left/custom-card2/custom-card2.component';
import { MatCardModule } from '@angular/material/card';


@NgModule({
  declarations: [
    ToolbarComponent,
    SplitterComponent,
    MenuLeftComponent,
    CustomCard2Component,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatToolbarModule,
    MatDividerModule,
    MatIconModule,
		MatCardModule,
  ],
  exports:[
    SplitterComponent,
    ToolbarComponent,
    MenuLeftComponent
  ]
})
export class LayoutModule { }
